// Global mobile UX fix: the on-screen keyboard frequently covers the field
// the user just tapped, especially inside modals/checkout panels where the
// browser's native "scroll input into view" behavior is unreliable (fixed-
// position containers, nested scroll areas). This listens for any form
// field gaining focus anywhere in the app and scrolls it into a centered,
// comfortable position once the keyboard's entrance animation has settled --
// so every form gets this for free, with no per-form wiring needed.
//
// Scoped to coarse-pointer (touch) devices only -- on a mouse/trackpad
// there's no keyboard covering anything, so re-centering the page on every
// field click would just be a disorienting jump for desktop users.
const FOCUSABLE_SELECTOR = 'input, textarea, select, [contenteditable="true"]';
const SETTLE_DELAY_MS = 320; // lets the keyboard/modal-transition animation finish before measuring

function isTextEntryField(el) {
  if (!(el instanceof HTMLElement)) return false;
  if (!el.matches(FOCUSABLE_SELECTOR)) return false;
  if (el instanceof HTMLInputElement && ['checkbox', 'radio', 'range', 'color', 'button', 'submit', 'reset', 'file'].includes(el.type)) {
    return false;
  }
  return true;
}

export function initAutoScrollToFocusedInput() {
  if (typeof window === 'undefined' || !window.matchMedia?.('(pointer: coarse)').matches) return;

  document.addEventListener('focusin', (e) => {
    const el = e.target;
    if (!isTextEntryField(el)) return;
    setTimeout(() => {
      el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
    }, SETTLE_DELAY_MS);
  });
}
